module.exports = __webpack_public_path__ + "img/house-2.7c63beef.jpg";